import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/** Page-wide notice for something that is done, still running or just to know, the counterpart of `ui-api-error`. */
@Component({
  selector: 'ui-status-notice',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './status-notice.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusNoticeComponent {
  readonly headline = input.required<string>();
  readonly message = input.required<string>();
  readonly state = input<'done' | 'busy' | 'info'>('done');
  readonly showBack = input(false);
  readonly backDisabled = input(false);
  readonly back = output();
}
